export const SWITCH_MENU_STATE = "SWITCH_MENU_STATE";

interface SwitchMenuStateAction {
    type: typeof SWITCH_MENU_STATE,
    newState: string
}

export type AppActionTypes = SwitchMenuStateAction;